import { SearchTermType } from './types';

const INITIAL_STATE: any = {
  sections: {},
};

export const cmsReducer = (state: any = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CMS/REQUEST_CATEGORIES': {
      const { sectionId } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetching: true,
          },
        },
      };
    }

    case 'CMS/RECEIVE_CATEGORIES_SUCCESS': {
      const { sectionId, sitemap, sitemapObj } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetching: false,
            sitemap,
            byId: sitemapObj,
          },
        },
      };
    }

    case 'CMS/RECEIVE_CATEGORIES_ERROR': {
      const { sectionId, error } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetching: false,
            error,
          },
        },
      };
    }

    case 'CMS/RECEIVE_SECTION_META': {
      const { sectionId, meta } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            sectionMeta: meta,
          },
        },
      };
    }

    case 'CMS/REQUEST_ARTICLES': {
      const { sectionId } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetchingArticles: true,
          },
        },
      };
    }

    case 'CMS/RECEIVE_ARTICLES_SUCCESS': {
      const { sectionId, articles } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetchingArticles: false,
            allArticles: articles,
          },
        },
      };
    }

    case 'CMS/RECEIVE_ARTICLES_ERROR': {
      const { sectionId, error } = action.payload;
      return {
        ...state,
        sections: {
          ...state.sections,
          [sectionId]: {
            ...state.sections[sectionId],
            isFetchingArticles: false,
            error,
          },
        },
      };
    }

    default: {
      return state;
    }
  }
};

const searchFormReducer = (
  state = {
    searchTerm: '',
  },
  action: SearchTermType,
) => {
  switch (action.type) {
    case 'Header/REQUEST_SEARCH_TERM': {
      return {
        searchTerm: action.payload.searchTerm,
        isFetching: true,
      };
    }

    case 'Header/RECEIVE_SEARCH_TERM_SUCCESS': {
      if (action.payload.searchTerm !== state.searchTerm) {
        return state;
      }
      return {
        ...state,
        isFetching: false,
        results: {
          productsResult: action.payload.articles,
        },
      };
    }

    case 'Header/RECEIVE_SEARCH_TERM_ERROR': {
      return {
        isFetching: false,
        error: action.payload.error,
      };
    }

    default: {
      return state;
    }
  }
};
